export default __webpack_public_path__ + "static/media/datainsights.b0efd7ba.gif";